
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["zipFiles"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "built-zipFiles.08e391.worker.js", { name: "built-zipFiles.[hash:6].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			